/* eslint-disable */
import React, { RefObject, Suspense, useRef } from 'react'
import Model from './Model'
import { OrbitControls } from '@react-three/drei'
import { Canvas } from '@react-three/fiber'
import { CameraControls } from './CameraControls'

interface ModelWrapperProps {
  cameraControls: RefObject<CameraControls | null>
}

const ModelWrapper = ({ cameraControls }: ModelWrapperProps) => {
  return (
    <div className='bg-transparent w-full md:w-1/2 h-[50vh] md:h-full md:absolute top-0 right-0'>
      <Canvas camera={{ position: [1, 0, -65] }} gl={{ toneMappingExposure: -0.3 }}>
        {/*@ts-ignore*/}
        <CameraControls ref={cameraControls} />
        <ambientLight intensity={0.2} />
        <directionalLight intensity={0.2} position={[80, 400, -200]} />
        <pointLight intensity={2.4} position={[100, 200, -400]} distance={1000} />
        <Suspense fallback={null}>
          <Model position={[-5, 0, -2]} rotation={[0, Math.PI / 3.5, 0]} />
        </Suspense>
        <OrbitControls enableZoom={false} enableRotate={false} />
      </Canvas>
    </div>
  )
}

export default ModelWrapper
